window.jQuery = require('jquery');
window.$ = window.jQuery;
window._ = require('lodash');
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.Vue  = require('vue');
window.Swal = require('sweetalert2');
window.ToastrNotifications = require('toastr');
window.select2 = require('select2');
window.VueMask = require('v-mask');
window.Slider = require('../prolearning/js/zSlider.min');
require('../prolearning/js/classie.js');
require('jquery-appear-original');

require('../prolearning/js/selectivizr-min');
require('../prolearning/js/select2.full.min');
require('../prolearning/js/slick.min');
require('../prolearning/js/mask');
require('../prolearning/js/bootstrap.bundle.min');
require('../prolearning/js/bootstrap-select.min');
require('../prolearning/js/jquery.scrollbar.min');
require('../prolearning/js/jquery.magnific-popup.min');
require('../prolearning/js/datepicker.min');
require('../prolearning/js/app');
require('../prolearning/js/main');
require('../prolearning/js/tabUtils');
require('../prolearning/js/print');
require('../prolearning/js/components/toggleTarget');
require('../prolearning/js/components/authorization');
require('../prolearning/js/components/menu');
